import { action, observable } from 'mobx';
import axios from 'axios';

import { isBoolean } from '~/common/utils/typeCheckers.js';

export default class SharedFormUtilsClass {
    @observable displayOptIn = false;
    @observable emailAlreadyUsedError = false;

    constructor(rootStore) {
        this.formsStore = rootStore.formsStore;
    }

    @action setDisplayOptIn(bool) {
        this.displayOptIn = isBoolean(bool, this.displayOptIn);
    }

    @action setEmailAlreadyUsedError(bool) {
        this.emailAlreadyUsedError = isBoolean(bool, this.emailAlreadyUsedError);
    }

    // validate Email
    @action validateEmail(email, successCallback, errorCallback) {
        // verify email
        axios.get(`/api/User?username=${email}`)
            .then((response) => {
                // if the number is avalible procceed to the next step
                if (response.data && response.data.IsAvailable) {
                    successCallback(response);
                } else {
                    // if the email is already used, block the users from signing up
                    this.setEmailAlreadyUsedError(true);
                    errorCallback();
                }
            }).catch((err) => {
                return err;
            });
    }
}
